/**
 * Scroll to top function to be attached to back/next event listeners
 */
export const ScrollToTop = () => {
    const target = document.querySelector('.farm-calc-top-navigation');
    if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
    }
} 
